import { Settings } from "lucide-react";
import useI18n from "../hooks/useI18n";
import locales from "../locales.json";

function Logo() {
    const { t } = useI18n(locales);
    return (
        <div className="flex items-center gap-2">
            <img src="/logo512.png" alt={`${t("app.name")} logo`} className="h-8 w-8 rounded-xl object-cover" />
            <span className="text-lg font-semibold tracking-tight">{t("app.name")}</span>
        </div>
    );
}

export default function Layout({ user, children, onOpenSettings }) {
    const { t } = useI18n(locales);
    return (
        <div className="min-h-screen bg-slate-950 text-white">
            <header
                className="fixed inset-x-0 h-14 flex items-center justify-between px-4 border-b border-white/10 bg-slate-900 z-[10000]"
                style={{ top: "env(safe-area-inset-top, 0px)" }}
            >
                <div className="text-lg font-semibold"><Logo /></div>
                <div className="flex items-center gap-3">
                    <div className="text-white/70 text-sm">{user?.username}</div>
                    <button
                        onClick={onOpenSettings}
                        className="p-2 rounded-xl hover:bg-white/10 active:scale-95 transition"
                        aria-label={t("mobile.settings")}
                        title={t("mobile.settings")}
                    >
                        <Settings className="w-5 h-5" />
                    </button>
                </div>
            </header>
            <main style={{ paddingTop: "calc(56px + env(safe-area-inset-top, 0px))" }}>
                {children}
            </main>
        </div>
    );
}
